import {BaseService, POST, Response, ResponseType} from 'ts-retrofit';
import {Language} from '../../../../models/vision/movie';

const base = 'catalogue';

export class CatalogueApiService extends BaseService {
  @POST(`/${base}/excel/admin`)
  @ResponseType('blob')
  async downloadExcel(): Promise<Response<Blob>> {
    return <Response>{};
  }

  @POST(`/${base}/pdf/admin`)
  @ResponseType('blob')
  async downloadPdf(): Promise<Response<Blob>> {
    return <Response>{};
  }
}


export interface DownloadRequest {
  // Sorting (from SortableRequest)
  sortingKey?: string;
  sortingDirectionAsc?: boolean;
  from?: number;
  amount?: number;
  genericFilter?: string;

  // Filters (from FilterMovieRequest)
  language?: Language; // default is Italian on server side
  title?: string;
  year?: number;
  fromYear?: number;
  toYear?: number;
  ltr?: Date;
  genreIds?: number[];

  pay1?: boolean;
  pay2?: boolean;
  pay3?: boolean;
  svod?: boolean;
  freeTv?: boolean;
  reserved?: boolean;
  available?: boolean;
  availableFrom?: Date;
  timeFrom?: Date;
  timeTo?: Date;
  searchText?: string;
  onlyPublished?: boolean;
  current?: boolean;
  reRun?: boolean;
  library?: boolean;

  exclusive?: boolean;
  coExclusive?: boolean;
  notExclusive?: boolean;
}
